export default __webpack_public_path__ + "static/media/loyalty.79b7df47.png";